import React from 'react'
import { Section } from './s'
import { H1 as Title } from 'components/typography/heading'

export const About = ({ name }) => (
    <Section>
        <Title>{name}</Title>
    </Section>
)